export interface SellerInfo {
  walletAddress: string
  nickName: string
}

export interface MarketplaceItemRef {
  // Could be a character instance or a weapon
  _id?: string
  characterId?: string
  rarity?: 'common' | 'rare' | 'legendary'
  level?: number
  experience?: number
  // add more fields as backend provides
}

export interface MarketplaceItem {
  _id: string
  seller: SellerInfo
  itemId: string
  itemRef: MarketplaceItemRef
  price: number
  trade: boolean
}

export interface MarketplaceState {
  items: MarketplaceItem[]
  isLoading: boolean
  error?: string
}

export const initialMarketplaceState: MarketplaceState = {
  items: [],
  isLoading: false,
}
